export const HELP_DATA = {
	"nav-support-text": "Support",
	"nav-help-text": "Help",
	"quick-guide-btntext": "Quick Guide",
	"condensed-guide": "Condensed Guide",
	"video-tutorials-btntext": "Video Tutorials",
	"support-contacts": "Support Contacts",
	general: "General",
	"global-support": "Global Support",
	"help-email": "abserp@eagle.org",
	"FAQ-more": "FAQ & More",
	"required-text": "What is required for EU MRV?",
	"IMO-required-text": "What is required for IMO DCS?",
	"submit-thetis": "THETIS: ",
	"review-the-regulation": "Review the regulation: ",
	"EU-MRV-link1": "https://mrv.emsa.europa.eu/#public/eumrv",
	"EU-MRV-link2":
		"https://ww2.eagle.org/en/Products-and-Services/abs-advisory-services/environmental-performance/EU-MRV.html",
	"imo-dcs-link":
		"https://ww2.eagle.org/en/Products-and-Services/abs-advisory-services/environmental-performance/imo-dcs.html",
	"import-report-link":
		"/assets/videos/importreport.mp4",
	"validation-link":
		"/assets/videos/validation.mp4",
	"create-child-report-link":
		"/assets/videos/createchildreport.mp4",	
	"submit-child-report-link":
		"/assets/videos/submitchildreport.mp4",	
	"eu-ets-link":
		"/assets/videos/euetssof.mp4",		
};
